import { useEffect, useMemo, useState } from "react";
import InformationCell from "../Tabellen/InformationCell";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import VvUpdate from "./VvUpdate";
import VvCreate from "./VvCreate";
import { csvHeaderVv, vvHeader } from "../Tabellen/ConstTabKopf/VerkehrsvertragKopf";
import StammdatenExport from "../Stammdaten/StammdatenExport";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

export default function VvLaden({ vvInstance, vvArtInstance, evuInstance, zvInstance, setTable, goBack }) {
    const [tableData, setTableData] = useState(null);
    const [vvArtData, setVvArtData] = useState();
    const [evuData, setEvuData] = useState();
    const [zvData, setZvData] = useState();

    const reloadData = () => {
        setTableData();
        let loading = new Promise((result) => {
            vvInstance.getVerkehrsvertragVerkehrsvertragGet((error, data, response) => {
                if (error) {
                    console.error(error);
                    FehlerauswertungErrResp(error, response);
                } else {
                    data.forEach(element => {
                        element.beginn = element.beginn.toLocaleDateString();
                        if (element.ende) {
                            element.ende = element.ende.toLocaleDateString();
                        }
                        element.korr_zvs_str = element.korr_zvs.map(zv => zv.name).join(', ');
                    });
                    result(data);
                }
            });
        })
        loading.then(d => setTableData(d));
    }

    useEffect(() => {

        vvInstance.getVerkehrsvertragVerkehrsvertragGet((error, data, response) => {
            if (error) {
                console.error(error);
                FehlerauswertungErrResp(error, response);

            } else {
                console.log('load vv')
                data.forEach(element => {
                    element.beginn = element.beginn.toLocaleDateString();
                    if (element.ende) {
                        element.ende = element.ende.toLocaleDateString();
                    }
                    element.korr_zvs_str = element.korr_zvs.map(zv => zv.name).join(', ');
                });
                setTableData(data);
                console.log(data)
            }
        });

        vvArtInstance.getVerkehrsvertragsartVerkehrsvertragsartGet((error, data) => {
            if (error) {
                console.log('error', error);
            } else {
                console.log('load vvarten');
                setVvArtData(data);
            }
        })

        evuInstance.getEvuEisenbahnverkehrsunternehmenGet((error, data) => {
            if (error) {
                console.log('error', error);
            } else {
                console.log('load evu', data);
                setEvuData(data);
            }
        })
        let opts = {
            'onlyActive': true // Boolean | 
        };
        zvInstance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
            if (error) {
                console.log(error);
            } else {
                console.log(data)
                setZvData(data);
            }
        })

    }, [vvInstance, vvArtInstance, evuInstance, zvInstance])

    const prepData = useMemo(() => tableData, [tableData]);
    const updateCol = {
        id: "update",
        Header: "",
        keyword: "Änderungen",
        Cell: ({ row }) => (
            <div>
                <VvUpdate rowEntry={row} instance={vvInstance} evus={evuData} arten={vvArtData} zvs={zvData} reloadData={reloadData} />
            </div>
        )
    }
    const commCol = {
        id: "comment",
        Header: "",
        keyword: "Info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            'Verkehrsvertrag': it.vertrag,
            'Vertragsart': it.art,
            'Eisenbahnverkehrsunternehmen': it.evu,
            'zugehörige Zweckverbände': it.korr_zvs_str,
            'seit': it.beginn,
            'bis': it.ende,
            'Kommentar': it.kommentar
        }))
    }

    return (
        <>
            <VvCreate vvInstance={vvInstance} zvInstance={zvInstance} vvArtInstance={vvArtInstance} evuInstance={evuInstance} reloadData={reloadData} />
            <div>
                {tableData
                    ? <div>
                        <GeneralTable data={prepData} columns={vvHeader} hiddenColumns={[]} additionalColumns={[commCol, updateCol]} reloadData={reloadData} />
                        <StammdatenExport csvedData={csvIt(prepData)} csvHeader={csvHeaderVv} csvFilename={"sd_vv"} />
                    </div>
                    : <DatenLaden />}
            </div>
        </>
    );
}